import { FormEvent, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { DadosCadastro, registrar } from '../../api/auth';
import { Button } from '../../components/Button';
import { ImageField } from '../../components/ImageField';
import { Input } from '../../components/Input';
import { PasswordInput } from '../../components/PasswordInput';
import { AuthSplitLayout } from '../../components/AuthSplitLayout';
import { useAuth } from '../../context/AuthContext';
import { lerArquivoComoDataUrl } from '../../utils/arquivos';
import { formatarCelular } from '../../utils/mascaras';

const CAMPOS_INICIAIS: DadosCadastro = {
  empresa: '',
  nome: '',
  email: '',
  celular: '',
  senha: '',
  logo_base64: null,
};

export function Cadastro() {
  const [dados, setDados] = useState(CAMPOS_INICIAIS);
  const [enviando, setEnviando] = useState(false);
  const { setUsuario } = useAuth();
  const navigate = useNavigate();

  function handleChange(campo: keyof DadosCadastro) {
    return (event: React.ChangeEvent<HTMLInputElement>) =>
      setDados((atual) => ({ ...atual, [campo]: event.target.value }));
  }

  async function handleLogoChange(file: File | null) {
    if (!file) return;
    try {
      const logoBase64 = await lerArquivoComoDataUrl(file);
      setDados((atual) => ({ ...atual, logo_base64: logoBase64 }));
    } catch (error: any) {
      Swal.fire({ icon: 'error', title: 'Nao foi possivel carregar a logo', text: error.message });
    }
  }

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    setEnviando(true);

    try {
      const { usuario } = await registrar(dados);
      setUsuario(usuario);
      Swal.fire({ icon: 'success', title: 'Conta criada com sucesso!', confirmButtonColor: '#1845ba' });
      navigate('/painel');
    } catch (error: any) {
      Swal.fire({
        icon: 'error',
        title: 'Nao foi possivel cadastrar',
        text: error.response?.data?.erro || 'Verifique os dados informados.',
        confirmButtonColor: '#1845ba',
      });
    } finally {
      setEnviando(false);
    }
  }

  return (
    <AuthSplitLayout titulo="Cadastro" subtitulo="Crie sua conta e personalize a empresa.">
      <form onSubmit={handleSubmit} className="lizzi-auth-form">
        <div className="lizzi-auth-form-grid">
          <div className="lizzi-auth-grid-span-2">
            <Input
              label="Nome da empresa"
              value={dados.empresa}
              onChange={handleChange('empresa')}
              required
              placeholder="Nome do restaurante"
            />
          </div>

          <div className="lizzi-auth-grid-span-2">
            <ImageField
              id="logo-empresa"
              label="Logo da empresa"
              previewUrl={dados.logo_base64}
              onChange={handleLogoChange}
              onRemove={() => setDados((atual) => ({ ...atual, logo_base64: null }))}
              helperText="PNG, JPG ou WEBP"
              variant="wide"
            />
          </div>

          <Input
            label="Seu nome"
            value={dados.nome}
            onChange={handleChange('nome')}
            required
            placeholder="Nome do responsavel"
          />

          <Input
            label="Celular"
            value={dados.celular}
            onChange={(e) => setDados((atual) => ({ ...atual, celular: formatarCelular(e.target.value) }))}
            placeholder="(11) 99999-9999"
            maxLength={15}
          />

          <div className="lizzi-auth-grid-span-2">
            <Input
              label="E-mail"
              type="email"
              value={dados.email}
              onChange={handleChange('email')}
              required
              placeholder="voce@empresa.com"
            />
          </div>

          <div className="lizzi-auth-grid-span-2">
            <PasswordInput
              label="Senha"
              value={dados.senha}
              onChange={handleChange('senha')}
              minLength={8}
              required
              placeholder="Minimo de 8 caracteres"
            />
          </div>
        </div>

        <Button type="submit" disabled={enviando}>
          {enviando ? 'Criando conta...' : 'Criar conta'}
        </Button>
      </form>

      <div className="lizzi-auth-bottom-copy">
        <span>Ja tem acesso?</span>
        <Link to="/login">Entrar</Link>
      </div>
    </AuthSplitLayout>
  );
}
